import React, { useState } from "react";
import CustomDropdown from "../../components/CustomComponents/CustomDropdown";
import "./styles/DropdownMenuBtn.scss";
const DropdownMenuBtn = (props) => {

  const { handleResponse,
    handleCopyClick,
    handleEditClick, handleViewClick, data, label } = props;

  const [menu, setMenu] = useState(false);
  const onDeleteOrder = async () => {

  }

  const onEditOrder = () => {
    handleEditClick(data);
  }
  const onViewClick = () => {
    handleViewClick(data);
  }
  const onCopy = () => {
   
      handleCopyClick(data);
  }

  const items = [
    { label: label ? label : 'View Order', onClick: onViewClick },
    // TODO: Phase 2 - Copy and Edit Purchase Order"
    // handleCopyClick && { label: 'Copy Order', onClick: onCopy },
    // { label: label ? label : 'Edit Order', onClick: onEditOrder },
    // { label: 'Delete Order', onClick: onDeleteOrder }
  ]

  if (handleCopyClick) {
    items.push( { label: 'Copy', onClick: onCopy } );
  }

  return (
    <CustomDropdown
      isOpen={menu}
      direction={'down'}
      toggle={() => setMenu(!menu)}
      items={items}
    />
  );
}
export default DropdownMenuBtn;